@switch (recordType()) {
    @case (ObjectTypesEnum.TOPIC) {
        <mat-icon>topic</mat-icon>
    }
    @case (ObjectTypesEnum.RUNDOWN) {
        <mat-icon>dns</mat-icon>
    }
    @case (ObjectTypesEnum.SCRIPT) {
        <st-story-icon
            disabled
            [type]="subType()" />
    }
}
